import React, { useMemo, useState } from "react"
import { RouteComponentProps, useParams } from "react-router-dom"
import { Col, Form, Input, Row } from "antd"
import SettingsPageEdit from "components-old/common/SettingsPage/SettingsPageEdit"
import { useStoreState } from "hooks"
import { IChannel } from "models/channels"
import { ChannelStatus } from ".."
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import { channelsDef } from "../channels.def"
import { isAldeia } from "hooks/useAldeia"

interface IEditVoipProps extends RouteComponentProps<{ id: string }> {
  onChange: Function
}

function EditVoip(props: IEditVoipProps) {
  const [form] = Form.useForm()
  const { all: channels } = useStoreState((state) => state.channels)
  const { id } = useParams<any>()
  const [item, setItem] = useState<IChannel>()

  const channel = useMemo(() => {
    return channels.find((c) => c.id == id)
  }, [channels, id])

  const def = channelsDef.record.voip

  return (
    <SettingsPageEdit<IChannel>
      {...props}
      pageComponent={isAldeia ? "drawer" : "modal"}
      routeName="channels"
      onChangeItem={(item) => setItem(item)}
      title="Canal de Voip"
      onSubmitSuccess={() => {
        props.onChange()
      }}
      titleOverwrite={
        <Row justify="space-between" align="middle" wrap={false}>
          <Col>
            <Row wrap={false}>
              <Col className="fc">
                <i className="size-9 shrink-0 mr-2.5 [&_.g-icon-wrapper]:!p-[5px]">{def.icon}</i>
              </Col>
              <Col className="truncate" title={channel?.description} style={{ display: "flex", alignItems: "center" }}>
                {channel?.description}
              </Col>
            </Row>
          </Col>
        </Row>
      }
      storePath={(store) => store.channelsVoip}
      form={form}
      hideFooterWhenSaved
    >
      <Form.Item label="Status">
        <span className="inline-block">
          <ChannelStatus status={channel?.status} channel={channel} />
        </span>
      </Form.Item>
      <Form.Item
        label="Descrição"
        name="description"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input placeholder="Meu canal de Voip" />
      </Form.Item>
      <Form.Item
        label="Número de telefone"
        name="phone"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Razão social"
        name="razao_social"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="CNPJ"
        name="cnpj"
        rules={[
          {
            required: true,
            message: "Campo obrigatório",
          },
        ]}
      >
        <Input />
      </Form.Item>
      <EditEntityCustomFields form={form} item={item} entity="channel" />
    </SettingsPageEdit>
  )
}

export default EditVoip
